import React, { memo, useEffect } from 'react'

import { Pixel2, TPixel2Event } from './utils'
import { VERSION } from '../constants'

const MAPPING_CONFIG: Record<VERSION, { aid: number; eventDict: Record<TPixel2Event, number[]> }> =
  {
    mania1: {
      aid: 1875998911,
      eventDict: {
        visit: [91],
        regnotfin: [92],
        regfin: [93],
        landingpageview: [130],
      },
    },
    mania2: {
      aid: 1365473644,
      eventDict: {
        visit: [102],
        regnotfin: [103],
        regfin: [104],
        landingpageview: [131],
      },
    },
  }

interface PixelV2HandlerProps {
  userId: number | undefined
  mania: VERSION
}

const PixelV2Handler: React.FC<PixelV2HandlerProps> = ({ userId, mania }) => {
  useEffect(() => {
    Pixel2.init({
      aid: MAPPING_CONFIG[mania].aid,
      userId,
      eventDict: MAPPING_CONFIG[mania].eventDict,
    })

    return () => Pixel2.cleanup()
  }, [mania, userId])

  return null
}

export default memo(PixelV2Handler)
